module.exports = __webpack_public_path__ + "img/资源98.117ee8ba.png";